function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRussia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 85.331 512 341.337",
    style: {
      enableBackground: "new 0 85.33 512 341.337"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 85.331,
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 113.779
  }), /*#__PURE__*/React.createElement("rect", {
    y: 199.11,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 113.779
  }), /*#__PURE__*/React.createElement("rect", {
    y: 312.889,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 113.779
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRussia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "russia.4387fd93589bdc69d8b1cfb2dcf08c00.svg";